/* eslint-disable showpass-custom/no-hardcoded-colors */
/* eslint-disable showpass-custom/no-hardcoded-style-values */
import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function VisaLogo({
  outline,
  ...props
}: IconProps): JSX.Element {
  return outline ? (
    <VisaLogo.Outline {...props} />
  ) : (
    <VisaLogo.Solid {...props} />
  );
}

VisaLogo.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        {/**
         * Enter the contents of your SVG here without the <svg> tag.
         * For outlined icons, be sure to add `className="icon-outline"`
         * to each path that needs to be outlined.
         */}
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

VisaLogo.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,

    name: `${name}Solid`,

    path: (
      <>
        <rect width="70" height="48" rx="4" fill="#00579F" />
        <path
          d="M29.9482 32.1656H25.9902L28.4658 16.8584H32.4236L29.9482 32.1656Z"
          fill="white"
        />
        <path
          d="M44.2947 17.2327C43.514 16.923 42.2758 16.5811 40.7447 16.5811C36.8361 16.5811 34.0837 18.6653 34.0668 21.6452C34.0343 23.8438 36.0374 25.0649 37.5356 25.798C39.0669 26.5471 39.5874 27.036 39.5874 27.7037C39.5718 28.7292 38.35 29.2019 37.2105 29.2019C35.6303 29.2019 34.7836 28.9581 33.4969 28.3876L32.9757 28.1431L32.4219 31.5792C33.3502 32.0021 35.0604 32.3774 36.8361 32.3939C40.989 32.3939 43.6928 30.3418 43.7248 27.1663C43.7406 25.4238 42.6829 24.0886 40.4025 22.9975C39.0182 22.2971 38.1704 21.8249 38.1704 21.1082C38.1866 20.4568 38.8875 19.7895 40.4501 19.7895C41.7368 19.7568 42.6822 20.0661 43.3984 20.3756L43.7564 20.5381L44.2947 17.2327Z"
          fill="white"
        />
        <path
          d="M49.5572 26.7428C49.8832 25.8634 51.1374 22.46 51.1374 22.46C51.121 22.4927 51.4627 21.5644 51.6582 20.9945L51.9348 22.3134C51.9348 22.3134 52.6843 25.9775 52.847 26.7428C52.2285 26.7428 50.339 26.7428 49.5572 26.7428ZM54.4428 16.8584H51.3813C50.4372 16.8584 49.72 17.135 49.3126 18.1284L43.4336 32.1654H47.5866C47.5866 32.1654 48.2703 30.2761 48.4172 29.8692C48.8728 29.8692 52.9128 29.8692 53.4989 29.8692C53.6126 30.4066 53.9712 32.1654 53.9712 32.1654H57.6359L54.4428 16.8584Z"
          fill="white"
        />
        <path
          d="M22.684 16.8584L18.8078 27.2964L18.3843 25.1795C17.6676 22.7368 15.4202 20.0829 12.9121 18.7632L16.4625 32.1494H20.648L26.8692 16.8584H22.684Z"
          fill="white"
        />
        <path
          d="M15.2085 16.8584H8.84054L8.77539 17.1677C13.7428 18.4379 17.0326 21.4999 18.3843 25.1801L16.9999 18.1451C16.772 17.1675 16.0717 16.8906 15.2085 16.8584Z"
          fill="#FAA61A"
        />
      </>
    ),
  });

  return <Icon viewBox="0 0 70 48" {...validateKeys(props)} />;
};
